import { dateToFormatedString } from '@/infrastructure/date';

const initialState = {
  debt: [],
  clientBalance: 0,
  paymentsMap: {},
  total: 0,
  paymentMethod: '',
  selectedPayments: [],
  transactionData: {},
  xml1: null
};

export default {
  state: JSON.parse(JSON.stringify(initialState)),
  mutations: {
    SET_DEBT: (state, value) => {
      state.debt = value;
    },
    SET_CLIENT_BALANCE: (state, value) => {
      state.clientBalance = value;
    },
    SET_PAYMENTS_MAP: (state, value) => {
      state.paymentsMap = value;
    },
    SET_SELECTED_PAYMENTS: (state, value) => {
      state.selectedPayments = value;
    },
    SET_TOTAL: (state, value) => {
      state.total = value;
    },
    SET_PAYMENT_METHOD: (state, value) => {
      state.paymentMethod = value;
    },
    CLEAR_PAYMENT_DATA: state => {
      Object.keys(state).forEach(key => {
        const val = initialState[key];
        if (val !== undefined) {
          state[key] = JSON.parse(JSON.stringify(val));
        } else {
          delete state[key];
        }
      });
    },
    SET_TRANSACTION_DATA: (state, value) => {
      state.transactionData = value;
    },
    DELETE_TRANSACTION_DATA: state => {
      state.transactionData = {};
    },
    SET_XML1: (state, value) => {
      state.xml1 = value;
    }
  },
  actions: {
    setDebt: ({ commit }, debt) => {
      commit('SET_DEBT', debt);
    },
    setClientBalance: ({ commit }, clientBalance) => {
      commit('SET_CLIENT_BALANCE', clientBalance);
    },
    setPaymentMethod: ({ commit }, paymentMethod) => {
      commit('SET_PAYMENT_METHOD', paymentMethod);
    },
    setPaymentsMap: ({ commit }, paymentsMap) => {
      commit('SET_PAYMENTS_MAP', paymentsMap);
      const operationKeys = Object.keys(paymentsMap);
      let total = 0;
      operationKeys.forEach(operationId => {
        total += paymentsMap[operationId].reduce(
          (acum, current) => acum + current.secondaryCurrencyTotalMonthlyPayment, 0
        );
      });
      commit('SET_TOTAL', total);

      const selectedPayments = operationKeys.map(operationId => ({
        operationId,
        paymentsNumbers: paymentsMap[operationId].map(payment => payment.paymentNumber)
      }));
      commit('SET_SELECTED_PAYMENTS', selectedPayments);
    },
    clearPaymentData: ({ commit }) => {
      commit('CLEAR_PAYMENT_DATA');
    },
    setTransactionData: ({ commit }, transactionDataIn) => {
      const transactionData = JSON.parse(JSON.stringify(transactionDataIn));
      transactionData.subTotal = `$ ${new Intl.NumberFormat('de-DE').format(transactionDataIn.debtAmount)}`;
      transactionData.total = `$ ${new Intl.NumberFormat('de-DE').format(transactionDataIn.amount)}`;
      transactionData.date = dateToFormatedString(transactionDataIn.createdAt);
      commit('SET_TRANSACTION_DATA', transactionData);
    },
    deleteTransactionData: ({ commit }) => commit('DELETE_TRANSACTION_DATA'),
    setXML1: ({ commit }, xml1) => {
      commit('SET_XML1', xml1);
    }
  }
};
